import { createContext } from "react"
import { FlowsheetContent, LineRecord, NodeState, SetOperation, SheetContent } from "./services/modal"
import { SimulationModal } from "@/services/project/simulation.service"

interface FlowsheetContextModal {
  setSelectedSheet: (id: string) => void
  save: () => Promise<FlowsheetContent | undefined>
  print: () => Promise<void>
  changeCellProps: (id: string, props) => void
  runWithSimlation: (sim: SimulationModal) => void
  updateTopology: (sim: SimulationModal) => void
  handleTopology: (sim: SimulationModal, callback: Function) => any
  getAllUnits: () => Promise<{nodes: NodeState[], lines: LineRecord[], operations: SetOperation[]}>
  getCellById: (id: string) => LineRecord | NodeState | undefined
  isTemplate: boolean,
  template?: FlowsheetContent,
}

export const FlowsheetContext = createContext<FlowsheetContextModal>({
  setSelectedSheet: () => {},
  save: () => {return {} as any},
  print: () => Promise.resolve(),
  changeCellProps: (id: string, props) => {},
  runWithSimlation: (sim: SimulationModal) => {},
  updateTopology: (sim: SimulationModal) => {},
  handleTopology: (sim: SimulationModal, callback: Function) => {},
  getAllUnits: () => (Promise.resolve({nodes: [], lines: [], operations: []})),
  getCellById: (id: string) => undefined,
  isTemplate: false,
  template: undefined
})